"use client";

import Box from "@mui/material/Box";
import SalifyComponent from "src/lib/components/salify-component/default";
import {
  frameToClassName,
  getFrameViewport,
  groupComponentsByFrameId,
  groupFramesByRow,
  isFrameVisible,
  LayoutFrameModel,
  LayoutViewMode,
} from "./frame-layout.utils";

interface FramedLayoutRendererProps {
  document: {
    components?: any[];
    layoutFrames?: LayoutFrameModel[];
  };
  viewMode?: LayoutViewMode;
}

const FramedLayoutRenderer = (props: FramedLayoutRendererProps) => {
  const { document, viewMode = "desktop" } = props;
  const frames = document.layoutFrames || [];
  const componentsByFrame = groupComponentsByFrameId(document.components || []);
  const rows = groupFramesByRow(frames);

  return (
    <Box className="flex flex-col gap-0 w-full">
      {rows.map(({ row, frames: rowFrames }) => {
        const visibleFrames = rowFrames.filter((frame) => isFrameVisible(frame, viewMode));
        if (!visibleFrames.length) return null;

        return (
          <Box key={`site-row-${row}`} className="grid grid-cols-12 gap-0 w-full">
            {rowFrames.map((frame) => {
              if (!isFrameVisible(frame, viewMode)) return null;

              const viewport = getFrameViewport(frame, viewMode);
              const slotComponents = (componentsByFrame.get(frame.id) || []).filter(
                (item) => !(item.$type === "layout-children" && item.__sbEmpty),
              );

              return (
                <Box
                  key={frame.id}
                  className={`${frameToClassName(viewport, frame)} w-full`}
                  data-frame-id={frame.id}
                >
                  {slotComponents.length ? <SalifyComponent components={slotComponents} /> : null}
                </Box>
              );
            })}
          </Box>
        );
      })}
    </Box>
  );
};

export default FramedLayoutRenderer;
